import {
  briefProfilesJsonForAndroid,
  loadBriefProfileCollection,
  saveBriefProfileCollection,
} from "@/shared/brief/run-store";
import { migrateBriefProfileCollectionForCountryChange } from "@/shared/brief/styles";
import { migrateExplicitHomeCarouselDeckForCountry } from "@/shared/home-carousel/carousel-store";
import {
  marketRegionPreferenceTransition,
  normalizeMarketCountry,
} from "@/shared/preferences/market-region-transition.mjs";
import { loadPreferences, savePreferences, type WebPreferences } from "@/shared/preferences/store";

function marketCountry(value: unknown, fallback = "US"): string {
  return normalizeMarketCountry(value, fallback);
}

export function preferencesForMarketRegionChange(
  preferences: WebPreferences,
  targetCountryRaw: unknown,
  previousCountryRaw: unknown = preferences.country,
): WebPreferences {
  const previousCountry = marketCountry(previousCountryRaw);
  const targetCountry = marketCountry(targetCountryRaw, previousCountry);
  const transitioned = marketRegionPreferenceTransition(
    preferences,
    targetCountry,
    previousCountry,
  ) as WebPreferences;
  return transitioned;
}

export function savePreferencesWithMarketRegionChange(preferences: WebPreferences): WebPreferences {
  const previous = loadPreferences();
  const previousCountry = marketCountry(previous.country);
  const targetCountry = marketCountry(preferences.country, previousCountry);
  const countryChanged = previousCountry !== targetCountry;
  const normalized = preferencesForMarketRegionChange(preferences, targetCountry, previousCountry);
  const migratedBriefProfiles = countryChanged
    ? migrateBriefProfileCollectionForCountryChange(
        loadBriefProfileCollection(previousCountry),
        targetCountry,
      )
    : null;
  const next = migratedBriefProfiles
    ? {
        ...normalized,
        hiddenDefaultStockSymbols: "",
        briefProfilesJson: briefProfilesJsonForAndroid(migratedBriefProfiles),
        activeBriefProfileId: migratedBriefProfiles.activeProfileId,
      }
    : normalized;

  if (migratedBriefProfiles) {
    saveBriefProfileCollection(migratedBriefProfiles);
  }
  savePreferences(next, {
    persistHiddenDefaultStocks: countryChanged,
  });
  if (countryChanged) {
    migrateExplicitHomeCarouselDeckForCountry(previousCountry, targetCountry);
  }
  return loadPreferences();
}
